var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c(
            "EmptyModal",
            {
              attrs: { onModalClose: _vm.closeModal, modalData: _vm.modalData },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm.modalData.source, alt: "" },
                  }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "flex flex_gap_10 flex-wrap" },
            _vm._l(_vm.records, function (r, i) {
              return _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("img", {
                    staticClass: "pointer",
                    attrs: { alt: "img", src: r.url },
                    on: {
                      click: function ($event) {
                        return _vm.openImage(r.url)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("накладная: "),
                    _c("strong", [_vm._v(_vm._s(r.record.object_id))]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "загружена: " +
                        _vm._s(r.record?.details?.uploaded_by?.user_name) +
                        " (" +
                        _vm._s(_vm.printDate(r.record.created_at)) +
                        ")"
                    ),
                  ]),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }